<template>
  <div class="about">
    <Navbar />
    <home-banner />    
    <Section title="Create Account" small-text="Join us to make your brand bigger." component-name="Signup" class="mb-5" />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '../components/Navbar.vue'
import Section from '../components/Section.vue'
import Footer from '../components/Footer.vue'
import HomeBanner from '../components/banners/HomeBanner.vue'

export default {
  name: 'About',
  components: {
    Navbar,    
    HomeBanner,
    Section,
    Footer
  }
}
</script>